import { SlidersHorizontalIcon } from "lucide-react";

import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import { ButtonRebrand } from "@tudigo-monorepo/web-tudigo-components";

import { useSearchProjectsContext } from "../../state/search-projects.context";

export function SearchProjectsRefinementsMenuTrigger() {
  const { t } = useTranslation();
  const { setIsRefinementsMenuOpen } = useSearchProjectsContext();

  return (
    <ButtonRebrand
      onClick={() => setIsRefinementsMenuOpen(true)}
      variant="black"
      className="font-roobert flex h-10 w-full items-center gap-x-4 !p-3 text-sm md:hidden md:w-fit"
    >
      {t("search_projects_page.refinements.menu.trigger")}
      <SlidersHorizontalIcon className="h-5 w-5 text-white" />
    </ButtonRebrand>
  );
}
